<script setup lang="ts">
import { computed, toRef } from 'vue';

import { useCurrentPaymentSystem } from '@modules/payment-system-details/composables';

import type { IPaymentSystemRadioItemProps } from './types';

const props = defineProps<IPaymentSystemRadioItemProps>();
const model = defineModel<string>();

const { currentPaymentSystem } = useCurrentPaymentSystem(toRef(props, 'value'));

const isActive = computed(() => model.value === props.value);
</script>

<template>
  <label v-data-qa-auto-id="'VPaymentSystemRadioItem'"
    :for="`${name}-${value}`"
    class="flex min-h-14 cursor-pointer items-center justify-between rounded-lg border px-4 py-3 shadow"
    :class="{ 'bg-primary-100/50': isActive, 'pointer-events-none': disabled }"
  >
    <span class="flex items-center gap-2">
      <img
        v-if="currentPaymentSystem"
        :src="currentPaymentSystem.icon"
      >
      <span>{{ label }}</span>
    </span>
    <PRadioButton
      v-model="model"
      :input-id="`${name}-${value}`"
      :disabled="disabled"
      :name="name"
      :value="value"
    />
  </label>
</template>
